import MenuIcon from "@mui/icons-material/Menu";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";
import { mainColor } from "../../styles/global";

export const Wrapper = styled.div`
  padding: 6rem 7.5%;
  display: grid;
  place-items: center;
  grid-template-columns: 2.5fr 1.5fr;
  // background-image: url("img/amico 5.svg");
  blend-mode: multiply;
  background: linear-gradient(99.98deg, #aeecea 3.69%, #e6fffe 83.92%);
  // mix-blend-mode: multiply;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    div {
      width: 100%;
      margin-top:10px;
    }
  }
  @media screen and (max-width: 640px){
    padding: 1em 7.5%;
  }
`;

export const LeftBlurBackground = styled.div`
background: rgba(0, 128, 128, 0.21);
position: absolute;
bottom: 20px;
left: 50px;
z-index: -3;
filter: blur(200px);
width: 611px;
height: 611px;
border-radius: 100%;
@media screen and (max-width: 1045px){
  left: 0;
}
@media screen and (max-width: 768px){
  display: none;
}
`;

export const TopRightBlurBackground = styled.div`
position: absolute;
width: 611px;
height: 611px;
top: -90px;
right: 0;
background: rgba(0, 128, 128, 0.17);
filter: blur(250px);
border-radius: 100%;
z-index: -3;
@media screen and (max-width: 768px){

}
`;

export const RightBlurBackground = styled.div`
width: 578px;
height: 578px;
position: absolute;
bottom: 50px;
z-index: -100;
right: 0;
filter: blur(150px);
border-radius: 100%;
background: linear-gradient(180deg, rgba(0, 128, 128, 0.3) 0%, rgba(9, 4, 88, 0.3) 100%);
@media screen and (max-width: 768px){
  display: none;
}
`;


export const LeftSection = styled.div`
  // background:red;
  img {
    width: 98%;
  }
  @media screen and (max-width: 768px) {
    img {
    }
    div {
      img {
        height: 300px;
      }
    }
  }
`;
export const RightSection = styled.div`
  // background:green;
  overflow: hidden;

  img {
    width: 98%;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    img {
      margin-top: 1rem;
      width: 98%;
    }
  }
`;
export const HeaderImageWrapper = styled.div`
  img {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    img {
      width: 80%;
    }
  }
`;
export const Captiontext = styled.div`
  div {
    color: ${mainColor};
    font-family: "Avenir";
    font-style: normal;
    font-weight: 700;
    font-size: 46px;
    line-height: 55px;
    letter-spacing: 0.01em;
    @media screen and (max-width: 768px) {
      font-family: "Avenir";
      font-weight: 700;
      font-size: 27px;
      line-height: 39px;
      letter-spacing: 0.02em;
    }
  }
`;
export const HeroTextWrapper = styled.div`
  margin: 40px 0;
  margin-right: 160px;
  @media screen and (max-width: 768px) {
    margin-right: 0px;
    margin:10px 0;
  }
`;
export const MobileButtonSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 30px;
  div {
    &:hover {
      transition: all ease-in-out 0.7s;
      opacity: 0.7;
      cursor: pointer;
    }
  }
  @media screen and (max-width: 768px) {
    // flex-direction: column;
    // justify-content-center;

    gap: 0.5rem;
    div {
      width: 140px;
      display: flex;
      align-items: center;
      height: 60px;
      img {
        width: 100%;
      }
    }
  }
`;

export const EarlyAccessLink = styled(Link)`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.12em;
  text-transform: Uppercase;
  text-decoration: none;
  span {
    margin-top: 80px;
  }
  color: ${mainColor};
  cursor: pointer;
  &.active {
    color: ${mainColor};
    font-weight: bold;
  }
  @media screen and (max-width: 768px) {
    span {
      margin-top: 20px;
      font-family: "Avenir";
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 13px;
      letter-spacing: 0.1em;
      text-decoration: underline;
    }
  }
`;

export const Bars = styled(MenuIcon)`
  display: none;
  color: #fff;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;
export const BarWrapper = styled.div`
  display: none;
  color: #fff;
  background: white;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  /* Second Nav */
  //  margin-right: 24px;
  /* Third Nav */
  /* width: 100vw;
  white-space: nowrap; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;
  /* Third Nav */
  /* justify-content: flex-end;
  width: 100vw; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: ${mainColor};
  padding: 10px 22px;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  /* Second Nav */
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`;
